<template>
<div class='bodyer faq'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-wentiquestions1 float-left'></i>常见问题
                </div>
            </div>
        </div>
    </div>
    <div class='container'>
        <div class='row'>
            <div class='col-md-3 box-nav'>
                <div class='list-group yi-ul-nav'>
                    <li class='list-group-item' v-for='(item, key) in types'
                        :class='key == type ? "active" : ""' @click='deal_type(key, item)'>
                        <i class='icon iconfont' :class='item.icon'></i>
                        {{item.name}}
                    </li>
                    
                </div>
            </div>
            <div class='col-md-9 box-cont'>
                <div class='yi-title'>{{typeInfo.name}}</div>
                <div class='list' v-if='type != "repass" && type != "lost"'>
                    <ul class='yi-ul news'>
                        <li v-for='item in list' @click='show_faq(item)'>
                            <a :href='item.href'>{{item.question}}</a>
                            <span class='date'>{{item.created_at}}</span>
                        </li>
                    </ul>
                </div>

                <div class='box-repass' :class='type != "repass" ? "hidden" : ""'>
                    <div class='row'>
                        <div class='col-md-3'></div>
                        <div class='col-md-6'>
                            <div class='yi-tab'>
                                <ul class='nav nav-tabs'>
                                  <li class='active'>
                                    <a class='nav-link' data-toggle='tab' data-target='#by-mobile'>
                                        手机重置
                                    </a>
                                  </li>
                                  <li>
                                    <a class='nav-link' data-toggle='tab' data-target='#by-email'>
                                        邮件重置
                                    </a>
                                  </li>
                                </ul>
                                 
                                <div class='tab-content'>
                                    <div class='tab-pane fade active in' id='by-mobile'>
                                        <div class='form form-mobile'>
                                            <div class='form-group'>
                                                <input type='text' class='form-control' 
                                                    v-model='by_mobile.mobile' pattern='^[0-9]{11}$'
                                                    placeholder='手机号:' required 
                                                    data-error='请输入手机号'>
                                                <div class='help-block with-errors'></div>
                                            </div>
                                            <div class='form-group'>
                                                <div class='input-group'>
                                                    <input type='text' class='form-control'
                                                        v-model='by_mobile.sms_code' pattern='^[0-9]{6}$'
                                                        data-error='请输入6位数字验证码' 
                                                        placeholder='验证码:' required>
                                                    <span class='input-group-btn'>
                                                        <button class='btn btn-default' type='button'
                                                            @click='sendSms()' v-if='!this.forbid_sms'>
                                                            免费获取
                                                        </button>
                                                        <button class='btn btn-default' type='button'
                                                            disabled v-if='this.forbid_sms'>
                                                            {{forbid_sms}}s后重新发送
                                                        </button>
                                                    </span>
                                                </div>
                                                <div class='help-block with-errors'></div>
                                            </div>
                                            <div class='form-group'>
                                                <input type='password' class='form-control' 
                                                    v-model='by_mobile.password'
                                                    placeholder='密码:' pattern='^[_A-z0-9]{6,12}' required 
                                                    data-error='6-12位数字、字母或下划线'>
                                                    <div class="help-block with-errors"></div>
                                            </div>
                                            <button class='yi-btn orange block'
                                                @click='findPwdByMobile()'
                                                type='button'>确认</button>
                                        </div>
                                    </div>
                                    <div class='tab-pane fade' id='by-email'>
                                        <form class='form form-email'>
                                            <div class='form-group'>
                                                <input type='email' class='form-control' 
                                                    v-model='by_email.email'
                                                    placeholder='邮箱:' required 
                                                    data-error='邮箱格式错误'>
                                                <div class="help-block with-errors"></div>
                                            </div>
                                            <div class='form-group'>
                                                <div class='input-group'>
                                                    <input type='text' class='form-control'
                                                        v-model='by_email.email_code' pattern='^[0-9]{6}$'
                                                        data-error='请输入6位数字验证码' 
                                                        placeholder='验证码:' required>
                                                    <span class='input-group-btn'>
                                                        <button class='btn btn-default' type='button'
                                                            @click='sendEmailCode()' v-if='!this.forbid_email'>
                                                            免费获取
                                                        </button>
                                                        <button class='btn btn-default' type='button'
                                                            disabled v-if='this.forbid_email'>
                                                            {{forbid_email}}s后重新发送
                                                        </button>
                                                    </span>
                                                </div>
                                                <div class='help-block with-errors'></div>
                                            </div>
                                            <div class='form-group'>
                                                <input type='password' class='form-control' 
                                                    v-model='by_email.password'
                                                    placeholder='密码:' pattern='^[_A-z0-9]{6,12}' required 
                                                    data-error='6-12位数字、字母或下划线'>
                                                    <div class="help-block with-errors"></div>
                                            </div>
                                            <button class='yi-btn orange block'
                                                @click='findPwdByEmail()'
                                                type='button'>确认</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class='box-add-que' :class='type != "lost" ? "hidden" : ""'>
                    <br><br>
                    <table class='yi-table-form form-question'>
                        <tr>
                            <th>服务类型:</th>
                            <td>
                                <select class='form-control' v-model='question.type'>
                                    <option value='ac_data' selected>账号资料相关</option>
                                    <option value='ac_auth'>账号停权、解权相关</option>
                                    <option value='ac_recharge'>账号充值相关</option>
                                    <option value='ac_safe'>账号密保措施相关</option>
                                    <option value='item_lose'>游戏内物品被盗相关</option>
                                    <option value='item_return'>游戏内物品归还相关</option>
                                    <option value='game_guide'>游戏玩法、内容建议</option>
                                    <option value='game_error'>游戏内问题反馈</option>
                                    <option value='other'>其他建议或问题反馈</option>
                                </select>
                            </td>
                        </tr><tr>
                            <th>内容描述:</th>
                            <td>
                                <div class='form-group'>
                                    <textarea class='form-control' rows='5' 
                                        v-model='question.content' required>
                                    </textarea>
                                    <div class="help-block with-errors"></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td><button class='btn btn-warning btn-block' 
                                    @click='addQuestion()'>提交</button></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <br><br><br>
    </div>
</div>
</template>
<script type="text/javascript">
import Request from '@/common/Request'
import Notify from '@/common/Notify'
import Storage from '@/common/Storage'
import Common from '@/common/Common'
export default {
    data : function(){
        return {
            'types' : {
                'account' : {
                    'name' : '账号问题',
                    'icon' : 'iconfont icon-iconzh1'
                },
                'recharge' : {
                    'name' : '充值问题',
                    'icon' : 'iconfont icon-chongzhi1'
                },
                'safe' : {
                    'name' : '安全问题',
                    'icon' : 'iconfont icon-anquanwenti'
                },
                'lost' : {
                    'name' : '被盗申诉',
                    'icon' : 'iconfont icon-shensu'
                },
                'game' : {
                    'name' : '游戏问题',
                    'icon' : 'iconfont icon-youxi1'
                },
                'repass' : {
                    'name' : '密码重置',
                    'icon' : 'iconfont icon-weibiaoti560'
                },
                'other' : {
                    'name' : '其他问题',
                    'icon' : 'iconfont icon-qita'
                }
            },
            'type' : '',
            'typeInfo' :{}, 
            'list' : [],
            'page' : 1,
            'pageInfo' : {},
            'limit' : 10,
            'forbid_sms' : false,
            'forbid_email' : false,
            'by_mobile' : {
                'mobile' : '',
                'sms_code' : '',
                'password' : '',
                're_pass' : ''
            },
            'by_email' : {
                'email' : '',
                'email_code' : '',
                'password' : '',
                're_pass' : ''
            },
            'question' : {
                'type' : 'ac_data',
                'content' : ''
            }
        }
    },
    props : ['user', 'setUser'],
    methods : {
        //加载数据
        get_list : function(page){
            var page = page || 1
            var url = Request.createApi('/app/faq/list?where[relate_type]='+this.type+
                '&page='+page+'&limit='+this.limit)
            Request.get(url, res => {
                this.list = res.list
                this.page = page
                this.pageInfo = res.page_info
            })

            this.list = []
        },

        //显示答案
        show_faq : function(item){
            Storage.set('faq', item)
            Common.toUrl('/service/faq/item')
            return true
        },

        //类型处理
        deal_type : function(type, typeInfo){
            this.type = type
            this.typeInfo = this.types[type]
            if(type != 'repass' && type != 'lost'){
                this.type = type
                this.get_list(1)
            }else{
                this.type = type
            }
        },

        //提交问题
        addQuestion : function(){
            if($('.form-question').data('bs.validator').validate().hasErrors()){
                return false
            }

            var url = Request.createApi('/app/question/add')
            Request.post(url, this.question, res => {
                Notify.success('问题已提交，请等待答复，相关处理结果请在客服中心->服务记录里面查看!')
            })
        },
        //验证码发送
        sendSms : function(){
            if(!this.by_mobile.mobile){
                Notify.error('请输入手机号!')
                return false
            }

            var url = Request.createApi('/public/send-sms-code')
            var param = {
                'mobile' : this.by_mobile.mobile
            }
            Request.post(url, param, res => {
                Notify.success('验证码已发送!')
                this.forbid_sms = 60
                var loop = setInterval(() => {
                    this.forbid_sms--
                    if(this.forbid_sms < 1){
                        this.forbid_sms = false
                        clearInterval(loop)
                    }
                }, 1000)
            })
        },

        //验证码发送
        sendEmailCode : function(){
            if(!this.by_email.email){
                Notify.error('请输入邮箱!')
                return false
            }

            var url = Request.createApi('/public/send-email-code')
            var param = {
                'email' : this.by_email.email
            }
            Request.post(url, param, res => {
                Notify.success('验证码已发送!')
                this.forbid_email = 60
                var loop = setInterval(() => {
                    this.forbid_email--
                    if(this.forbid_email < 1){
                        this.forbid_email = false
                        clearInterval(loop)
                    }
                }, 1000)
            })
        },

        //findPwdByMobile
        findPwdByMobile : function(){
            if($('.form-mobile').data('bs.validator').validate().hasErrors()){
                return false
            }
            var url = Request.createApi('/app/user/find-pwd-by-mobile')
            Request.post(url, this.by_mobile, res => {
                Notify.success('密码设置成功!')
            })
        },

        //findPwdByEmail
        findPwdByEmail : function(){
            if($('.form-email').data('bs.validator').validate().hasErrors()){
                return false
            }
            var url = Request.createApi('/app/user/find-pwd-by-email')
            Request.post(url, this.by_email, res => {
                Notify.success('密码设置成功!')
            })
        }
    },
    mounted : function(){
        $(function () { 
            $('.form-mobile').validator()
            $('.form-email').validator()
            $('.form-question').validator()
        });
    },
    created : function(){
        var type = Common.getUrlParam('type') || 'account'
        window.scrollTo(0, 0)
        this.deal_type(type)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/service/Faq.vue